import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Host,
  input,
  OnDestroy,
  Optional,
  output,
  ViewChild,
} from '@angular/core';
import { isNullishOrWhitespace } from 'gain-lib/string';
import { Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'gax-select-search',
  templateUrl: './select-search.component.html',
  styleUrl: './select-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class SelectSearchComponent implements OnDestroy, AfterViewInit {
  @ViewChild('searchInput', { static: true })
  searchInput!: ElementRef<HTMLInputElement>;

  private search$ = new Subject<string>();
  searchChange = output<string | null>();
  placeholder = input<string>('Search');
  $onDestroy = new Subject<void>();

  matSelectParent!: MatSelect;

  constructor(@Host() @Optional() public hostMatSelect: MatSelect) {
    // this is a workaround for the MatSelect typeaheadDebounceInterval to allow for a longer debounce interval when typing
    this.matSelectParent = <MatSelect>hostMatSelect;
    this.matSelectParent.typeaheadDebounceInterval = 3000;

    this.search$
      .pipe(
        map((v) => (isNullishOrWhitespace(v) ? null : v)),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe((searchInput) => {
        this.searchChange.emit(searchInput);
      });
  }

  ngAfterViewInit(): void {
    this.matSelectParent.openedChange
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((opened) => {
        if (!opened) {
          this.emitSearchChange(null, true);
        }
      });
  }

  ngOnDestroy(): void {
    this.$onDestroy.next(undefined);
    this.$onDestroy.complete();
  }

  protected emitSearchChange(
    event: Event | null,
    clearInputValue: boolean = false,
  ): void {
    event?.preventDefault();
    let value = this.searchInput.nativeElement.value;
    if (clearInputValue) {
      this.searchInput.nativeElement.value = '';
      value = '';
    }
    this.search$.next(value);
  }
}

